import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1 - About */}
          <div>
            <h3 className="text-xl mb-4">Kolektif Oluşum</h3>
            <p className="text-gray-400 mb-4">
              Kolektif Oluşum, Türkiye'nin ve Avrupa'nın en büyük öğrenci
              ağıdır.
            </p>
            <div className="space-y-2">
              <div>
                <span className="text-gray-400">Instagram: </span>
                <a
                  href="https://instagram.com/kolektifolusum"
                  target="_blank"
                  className="text-blue-400 hover:text-blue-300"
                >
                  @kolektifolusum
                </a>
              </div>
              <div className="text-gray-400">
                <span>Adres: </span>
                <span>
                  Esentepe Mah. Büyükdere Cad. Ecza Sok. Pol Center, C Blok No:
                  C16, Levent Şişli/İstanbul
                </span>
              </div>
            </div>
          </div>

          {/* Column 2 - Empty for spacing */}
          <div></div>

          {/* Column 3 - Quick Links */}
          <div>
            <h3 className="text-xl mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/hakkimizda"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link
                  to="/etkinliklerimiz"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Etkinliklerimiz
                </Link>
              </li>

              <li>
                <Link
                  to="/indirimler"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  İndirimler
                </Link>
              </li>
              <li>
                <Link
                  to="/sss"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  SSS
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  İletişim
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="text-center text-gray-400 text-sm">
            © 2025 Kolektif Oluşum Derneği tarafından tüm hakları saklıdır.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
